<template>
  <v-avatar :size="size" v-on="activator">
    <img :alt="user.full_name" v-if="isPlatform || isCallCentre" :src="avatarSrc" />
    <v-icon v-else :color="iconColour">{{ typeIcon }}</v-icon>
  </v-avatar>
</template>

<script>
const assetURL = 'https://s3-eu-west-1.amazonaws.com/media.alternativebusinessfunding.co.uk/public/avatars';
export default {
  name: 'AbfOwnerAvatar',
  props: {
    user: {
      default: null
    },
    size: {
      default: 33
    },
    activator: {
      default: null
    }
  },
  computed: {
    isPlatform() {
      return this.user !== null && typeof this.user !== 'undefined' ? this.user.roles.includes('Platform') : false;
    },
    isCallCentre() {
      return this.user !== null && typeof this.user !== 'undefined' ? this.user.roles.includes('Call Centre') : false;
    },
    avatarSrc() {
      return this.user !== null
        ? `${assetURL}/${this.user.id}.png`
        : `${assetURL}/fa4b47dd-c7ee-4f80-9fac-b389588ba226.png`;
    },
    typeIcon() {
      if (this.user !== null && typeof this.user !== 'undefined') {
        // if (this.user.roles.includes('Call Centre')) {
        //   return 'fad fa-headset';
        // }
        if (this.user.roles.includes('Property Broker')) {
          return 'fad fa-user-hard-hat';
        }
      }
      return 'fad fa-user';
    },
    iconColour() {
      if (this.user !== null && typeof this.user !== 'undefined') {
        if (this.user.roles.includes('Property Broker')) {
          return 'orange';
        }
      }
      return 'grey';
    }
  }
};
</script>
